import React from 'react';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { TrustBar } from './components/TrustBar';
import { InteriorAISection } from './components/InteriorAISection';
import { FeaturesSection } from './components/FeaturesSection';
import { ProcessSection } from './components/ProcessSection';
import { PortfolioSection } from './components/PortfolioSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
export function App() {
  return <div id="top" className="min-h-screen w-full bg-white text-apple-black font-sans selection:bg-apple-blue selection:text-white relative overflow-x-hidden" data-id="element-0" data-mp="2wk06yte9u9rt">
      <a href="#hlavny-obsah" className="skip-link" data-id="element-1" data-mp="28sbad0uf2z52">
        Preskočiť na obsah
      </a>

      {/* Two soft decorative orbs, desktop only */}
      <div className="hidden lg:block gradient-orb w-[560px] h-[560px] bg-blue-300 top-[200px] -right-[220px] fixed" aria-hidden="true" data-id="element-2" data-mp="3ikr0s4yore8d" />
      <div className="hidden lg:block gradient-orb w-[480px] h-[480px] bg-purple-300 top-[900px] -left-[220px] fixed" aria-hidden="true" data-id="element-3" data-mp="3mjq1tehaqquj" />

      <Navigation data-id="element-4" data-mp="5otf64sd496" />
      <main id="hlavny-obsah" tabIndex={-1} className="relative z-10 focus:outline-none" data-id="element-5" data-mp="67yvnd9206b">
        <HeroSection data-id="element-6" data-mp="2zllduyaeeel5" />
        <TrustBar data-id="element-7" data-mp="2zm4vedw4z0yn" />
        <div className="section-gradient-4" data-id="element-8" data-mp="2zmwif0bo3qdb">
          <InteriorAISection data-id="element-9" data-mp="33mf0zpg0npcz" />
        </div>
        <div className="section-gradient-1" data-id="element-10" data-mp="33n6yx6x35z6f">
          <FeaturesSection data-id="element-11" data-mp="38lrs4mdx7ild" />
        </div>
        <div className="section-gradient-4" data-id="element-12" data-mp="38l053zye2t6p">
          <ProcessSection data-id="element-13" data-mp="38o4ct7b2c724" />
        </div>
        <div className="section-gradient-2" data-id="element-14" data-mp="3dlw6o6v9q38y">
          <PortfolioSection data-id="element-15" data-mp="3diry6xarslch" />
        </div>
        <div className="section-gradient-5" data-id="element-16" data-mp="nwc39wy9i3yd">
          <TestimonialsSection data-id="element-17" data-mp="nvan5e2e2r9s" />
        </div>
        <div className="section-gradient-3" data-id="element-18" data-mp="su43de928wdn">
          <FAQSection data-id="element-19" data-mp="sssr0q1jugax" />
        </div>
        <div className="bg-white border-t border-gray-100" data-id="element-20" data-mp="3685nh1tcguh">
          <ContactSection data-id="element-21" data-mp="34nbhsjeuzx5" />
        </div>
      </main>
      <Footer data-id="element-22" data-mp="3udaxmaph6r5r" />
    </div>;
}